import React from 'react';

function ChartHeader({ title, subtitle, orderName, dateRange }) {
    // Styles - te same co w ParetoChart
    const styles = {
        header: {
            marginBottom: '24px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start'
        },
        leftContent: {
            flex: 1
        },
        rightContent: {
            textAlign: 'right'
        },
        title: {
            fontSize: '18px',
            fontWeight: '600',
            color: 'rgb(52, 71, 103)',
            margin: '0 0 4px 0',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
        },
        titleRight: {
            fontSize: '18px',
            fontWeight: '600',
            color: 'rgb(52, 71, 103)',
            margin: '0 0 4px 0',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
        },
        subtitle: {
            fontSize: '15px',
            color: '#777',
            margin: '0',
            fontWeight: '400',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
        },
        subtitleRight: {
            fontSize: '15px',
            color: '#777',
            margin: '0',
            fontWeight: '400',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif'
        }
    };

    return (
        <div style={styles.header}>
            <div style={styles.leftContent}>
                <h2 style={styles.title}>{title}</h2>
                {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
            </div>

            {(orderName || dateRange) && (
                <div style={styles.rightContent}>
                    {orderName && <h2 style={styles.titleRight}>{orderName}</h2>}
                    {dateRange && <p style={styles.subtitleRight}>{dateRange}</p>}
                </div>
            )}
        </div>
    );
}

export default ChartHeader;